import servise from '@/router/axios'

export const addAdFlow = (data) => {
  return servise({
    url: '/slot/flowManage/matchSetFlow',
    method: 'post',
    async: false,
    data
  })
}

export const getAdFlow = (params) => {
  return servise({
    url: '/slot/flowManage/slotOneFlowSet',
    method: 'get',
    params
  })
}

export const audit = (data) => {
  return servise({
    url: '/slot/flowManage/slot/audit',
    method: 'put',
    data
  })
}

export const top = (data) => {
  return servise({
    url: '/top/flowTop',
    method: 'put',
    data
  })
}

export const update = (data) => {
  return servise({
    url: '/slot/flowManage/update/matchSetFlow',
    method: 'put',
    data
  })
}

export const upFlow = (data) => {
  return servise({
    url: '/flow/delete',
    method: 'delete',
    data
  })
}

export const getOrder = (params) => {
  return servise({
    url: '/slot/flow/get/slot/order',
    method: 'get',
    params
  })
}

export const upSlotStatus = (data) => {
  return servise({
    url: '/slot/flowManage/revise/state',
    method: 'put',
    data
  })
}

export const getProv = (params) => {
  return servise({
    url: '/webBaseArea/getProv',
    method: 'get',
    params
  })
}

export const getCity = (params) => {
  return servise({
    url: '/webBaseArea/getCity',
    method: 'get',
    params
  })
}
